import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/portfolio2.jpg";
import IMG3 from "../../assets/portfolio3.jpg";
import IMG4 from "../../assets/portfolio4.jpg";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.jpg";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "מכון כושר",
    github: "https://github.com/MatyMusic/cars",
    demo: "https://vermillion-cucurucho-d0b644.netlify.app/",
  },
  {
    id: 2,
    image: IMG2,
    title: "מכוניות ",
    github: "https://github.com/MatyMusic/jem",
    demo: "https://cars-maty-dev2022.netlify.app/",
  },
  {
    id: 3,
    image: IMG3,
    title: "אתר תפריטים למסעדה",
    github: "https://github.com/MatyMusic/food",
    demo: "maty-food.netlify.app/",
  },
  {
    id: 4,
    image: IMG4,
    title: "תיק עבודות ",
    github: "https://github.com/MatyMusic/Project-Creative-Design",
    demo: "portfolio-maty-2022.netlify.app/",
  },
  {
    id: 5,
    image: IMG5,
    title: "תיק עבודות #2",
    github: "https://github.com/MatyMusic/portfolio",
    demo: "https://maty-dev-king.netlify.app/",
  },
  {
    id: 6,
    image: IMG6,
    title: "בקרוב",
    github: "https://github.com/MatyMusic/jem",
    demo: "https://vermillion-cucurucho-d0b644.netlify.app/",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>הפרוייקטים שלי</h5>
      <h2>תיק עבודות</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3> {title} </h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  כנס לאתר
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
